(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_header-menu"] && !Shopify.designMode) return;
  try {
    // Brizma: Override prototype methods to definitively prevent menu items from being hidden in the overflow slot
  try {
    const originalSetAttribute = Element.prototype.setAttribute;
    Element.prototype.setAttribute = function(name, value) {
      if (name === 'slot' && value === 'overflow' && this.classList && this.classList.contains('menu-list__list-item')) {
        return;
      }
      originalSetAttribute.call(this, name, value);
    };

    const slotDescriptor = Object.getOwnPropertyDescriptor(Element.prototype, 'slot') || Object.getOwnPropertyDescriptor(HTMLElement.prototype, 'slot');
    if (slotDescriptor && slotDescriptor.set) {
      const originalSlotSet = slotDescriptor.set;
      Object.defineProperty(Element.prototype, 'slot', {
        set(value) {
          if (value === 'overflow' && this.classList && this.classList.contains('menu-list__list-item')) {
            return;
          }
          originalSlotSet.call(this, value);
        },
        get: slotDescriptor.get,
        configurable: true
      });
    }
  } catch (e) {
    console.error('Failed to patch Element prototype for overflow-list bypass', e);
  }

  // Brizma: el atributo "disabled" del web component <overflow-list> hace
  // que #reset() mueva todos los ítems de vuelta a la fila visible y deje
  // de esconder los que no caben detrás del botón "Más" — así el menú
  // siempre muestra todo (baja de línea si hace falta, según el CSS
  // normal de flex-wrap del propio componente).
  //
  // El componente inicializa sus referencias internas de forma asíncrona
  // (espera a que sus estilos carguen antes de armar el shadow DOM). Si se
  // llama a showAll() antes de eso, su propio código interno tira un error
  // (intenta leer refs que todavía no existen) y el reset nunca llega a
  // ejecutarse — poner el atributo "disabled" no basta para confirmar que
  // funcionó, así que en vez de eso se llama directo a showAll() (el
  // método público del componente) y se reintenta mientras siga fallando,
  // hasta un máximo de intentos para no quedar reintentando para siempre.
  function disableOverflow(element, attemptsLeft) {
    if (attemptsLeft <= 0) return;
    try {
      element.querySelectorAll('.menu-list__list-item').forEach(item => {
        if (item.getAttribute('slot') === 'overflow') {
          item.removeAttribute('slot');
        }
      });
      if (typeof element.showAll === 'function') {
        element.showAll();

        // showAll()/#reset() no limpia el atributo "minimum-reached" que
        // haya quedado de un cálculo previo — sin esto, setHeaderMenuStyle()
        // (en utilities.js) sigue pensando que el menú no cabe y fuerza el
        // header a modo "drawer" (mobile) aunque ya se estén mostrando
        // todos los ítems. Se quita, y se dispara un "resize" para que el
        // propio listener del tema (header-menu.js) vuelva a calcular
        // data-menu-style con la función real, sin duplicar su lógica acá.
        element.removeAttribute('minimum-reached');
        window.dispatchEvent(new Event('resize'));
        return;
      }
    } catch (error) {
      // Todavía inicializando: se reintenta en el próximo frame.
    }
    requestAnimationFrame(() => disableOverflow(element, attemptsLeft - 1));
  }

  customElements.whenDefined('overflow-list').then(() => {
    document.querySelectorAll('.overflow-menu').forEach((element) => {
      requestAnimationFrame(() => disableOverflow(element, 120));
    });
  });
  } catch(e) { console.error(e); }
})();

})();
